import type { PickerProps } from './types';

const PRESETS = ['*', 'null', 'https://example.com'];

export function CorsOriginPicker({ value, onChange }: PickerProps) {
  return (
    <div className="picker-row">
      {PRESETS.map((p) => (
        <button
          key={p}
          className={value === p ? 'pill active' : 'pill'}
          onClick={() => onChange(p)}
          type="button"
        >
          {p === window.location.origin ? `${p} (this origin)` : p}
        </button>
      ))}
      <button
        className="pill"
        onClick={() => onChange(window.location.origin)}
        type="button"
        title="Use this site's origin"
      >
        this origin
      </button>
    </div>
  );
}
